import React from 'react'
import { toast } from 'react-toastify'
import { getErrorMessage, callToaster } from './helpers'

// IF HANDLED ERRORS RETURN TRUE ELSE FALSE
export const handleErrors = error => {
  const errorMessage = getErrorMessage(error)

  // NOT TO HANDLE
  if (!(error.response && errorMessage !== null && errorMessage)) {
    return false
  } else if (errorMessage) {
    // HANDLE AND SHOW ERROR
    callToaster(toast.TYPE.ERROR, errorMessage)

    return true
  }
  return false
}
